/** Live outcomeMeta examples for /learn (#777): the current env's catalog, described, with one selected. */
import { useMemo, useState } from 'react';
import { useOutcomeMeta } from '../catalog/useOutcomeMeta';
import { useDescriber } from '../describe/useDescribe';
import { pickExamples, type LearnExample } from './example';

export interface LearnExamples {
  examples: LearnExample[];
  example: LearnExample | undefined;
  pick: (outcome: number) => void;
  state: 'loading' | 'error' | 'ready';
}

export function useLearnExamples(): LearnExamples {
  const metaQ = useOutcomeMeta();
  const describe = useDescriber(metaQ.data);
  const examples = useMemo(() => pickExamples(metaQ.data?.outcomes, describe.outcome, new Date()), [metaQ.data, describe]);
  const [picked, setPicked] = useState<number | null>(null);
  const example = examples.find((e) => e.meta.outcome === picked) ?? examples[0];
  const state = metaQ.isPending ? 'loading' : metaQ.isError ? 'error' : 'ready';
  return { examples, example, pick: setPicked, state };
}
